type DebounceTimer = {
  [key: number]: any;
};
export const useTaskIdDebouncer = (fn: any, ttl: number): any => {
  const debounceTimers: DebounceTimer = {};

  return function (...args) {
    const [, _, taskId] = args[0];

    if (!debounceTimers[taskId]) {
      const cleanUp = () => {
        clearTimeout(debounceTimers[taskId]);
        delete debounceTimers[taskId];
      };

      debounceTimers[taskId] = setTimeout(() => {
        fn(...args);
        cleanUp();
      }, ttl);
    }
  };
};
